import { db } from '../../firebase';
import firebase from 'firebase/app';

const testsCollectionRef: firebase.firestore.CollectionReference<firebase.firestore.DocumentData> = db.collection(
  'quizzes',
);
export default testsCollectionRef;
